var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickYes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.827 5a4.827 4.827 0 100 9.653 4.827 4.827 0 000-9.653zM4 9.827a5.827 5.827 0 1111.653 0A5.827 5.827 0 014 9.827z",
    fill: "#36354C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.143 8.268a.5.5 0 010 .707L9.36 11.758a.26.26 0 01-.367 0L7.51 10.275a.5.5 0 11.707-.707l.96.96 2.259-2.26a.5.5 0 01.707 0z",
    fill: "#36354C"
  })));
}
export default SvgTickYes;